export const receiptColumns = [
  {
    title: "日期",
    width: 140,
    // dataIndex: "date",
    key: "date",
    scopedSlots: { customRender: "date" },
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "收款单编号",
    width: 160,
    key: "receiptNo",
    dataIndex: "receiptNo",
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "金额",
    width: 140,
    key: "amount",
    scopedSlots: { customRender: "amount" },
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "付款时间",
    width: 180,
    key: "time",
    scopedSlots: { customRender: "time" },
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "收款方式",
    width: 140,
    key: "receiptTypeName",
    scopedSlots: { customRender: "receiptTypeName" },
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "合同编号",
    width: 400,
    key: "contractNo",
    scopedSlots: { customRender: "contractNo" },
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "操作",
    width: 88,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center"
  }
]
